// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k_u6wu4rS7ENKV5UzJU4{flex-direction:column;align-items:flex-end;display:flex;overflow:auto}.m5rzGislb4atTpX7TNFA{justify-content:space-between;gap:16px;width:100%;padding-top:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `k_u6wu4rS7ENKV5UzJU4`,
	"content": `m5rzGislb4atTpX7TNFA`
};
export default ___CSS_LOADER_EXPORT___;
